import { Component } from "@angular/core";

@Component({
    selector: "app-creativity",
    templateUrl: "./creativity.component.html",
    styleUrl: "./creativity.component.scss",
    standalone: false,
})
export class CreativityComponent {}
